import { render } from "./SortDropdown.vue?vue&type=template&id=550fd78c"
import script from "./SortDropdown.vue?vue&type=script&lang=js"
export * from "./SortDropdown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/poll/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/SortDropdown.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "550fd78c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('550fd78c', __exports__)) {
    console.log('reload')
    api.reload('550fd78c', __exports__)
  }
  
  module.hot.accept("./SortDropdown.vue?vue&type=template&id=550fd78c", () => {
    console.log('re-render')
    api.rerender('550fd78c', render)
  })

}


export default __exports__